module.exports = __webpack_public_path__ + "static/media/wallet-dark-bgr-big.82d37da7.png";